import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SignupRoutingModule } from './signup-routing.module';

import { SignupComponent } from './signup.component';
import { StartComponent } from './start/start.component';
import { PackageComponent } from './package/package.component';
import { CandidateComponent } from './applicant/candidate.component';
import { PaymentComponent } from './payment/payment.component';
import { AccountComponent } from './account/account.component';
import { CredentialingComponent } from './credentialing/credentialing.component';
import { SharedModule } from '@app/shared/shared.module'; 
import { OnlineComponent } from './online/online.component';
import { InviteComponent } from './invite/invite.component';

import {
  FadvComponentsModule,
  FadvStepperModule,
  FadvAlertModule,
  FadvApplicationModule,
  FadvBoxModule,
  FadvButtonModule,
  FadvCardModule,
  FadvGridModule,
  FadvLayoutModule,
  FadvTypographyModule,
  FadvCommonModule,
} from '@fa-switch-sharedservices/ng-elements';
import { AlertMessageModule } from '../alert-message/alert-message.module';

@NgModule({
  declarations: [OnlineComponent, InviteComponent, SignupComponent, StartComponent, PackageComponent, CandidateComponent, PaymentComponent, AccountComponent, CredentialingComponent],
  imports: [
    SharedModule,
    CommonModule,
    SignupRoutingModule,
    ReactiveFormsModule,
    FadvComponentsModule,
    FadvCardModule,
    FadvStepperModule,
    FadvCommonModule,
    FadvApplicationModule,
    FadvAlertModule,
    FadvLayoutModule,
    FadvGridModule,
    FadvButtonModule,
    FadvBoxModule,
    FadvTypographyModule,
    AlertMessageModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SignupModule { }
